module.exports = __webpack_public_path__ + "img/source04_1.cff3cd9a.png";